<template>
  <button
    v-if="showBackToTop"
    class="back-to-top"
    @click="backToTop"
  >
    <img src="https://download.hecoos.com/enlightv/2025-17/c97ffd76b131b2c2f724bec6da9b4ab3.png" alt="">
  </button>
</template>

<script>
export default {
  data() {
    return {
      showBackToTop: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.showBackToTop = scrollTop > 300;
    },
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style scoped>
.back-to-top {
  position: fixed;
  bottom: 190px;
  right: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 9999;
}
.back-to-top img{
  width: 60px;
  height: 60px;
}
</style>
